export const GOOGLE_CLIENT_ID =
  "962357420565-snpjcmse4ej6c8aum404qpt2kmrb6edm.apps.googleusercontent.com";
export const GOOGLE_CLIENT_SECRET = "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";
export const MAPS_API_KEY = "AIzaSyBB_ou3GdFq8n3oCoVpB8fNPQaMndh-_WI";

export const APPLE_CLIENT_ID =
  "MIGTAgEAMBMGByqGSM49AgEGCCqGSM49AwEHBHkwdwIBAQQgCn6wSnhZd5mt4UkYg5Ry33OZnHM4Myfn8ZkVnqxdRjSgCgYIKoZIzj0DAQehRANCAARwYqLZ3JJNiPYV4+9itBWtbt9doXESbWD5mT65PW9SXVXCAtQqJ0A5Apeeu146NOuTWfJPiz+RAnm06E4TvX2E";
export const AZURE_CLIENT_ID = "b05608db-516e-4e83-80fb-c7bcc4b8c130";

export const RAM_GOOGLE_CLIENTID =
  "305088742247-9rc2u90k1cch38th7q1mptik2j6h4t9q.apps.googleusercontent.com";
export const RAM_GOOGLE_CLIENT_SECRET = "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";

export const RAM_MAPS_API_KEY = "AIzaSyDUo4GlouO8XSR8uuBzE7_uWUjHrGKr-u0";
